<template>
	<div>
		<table class="table">
			<thead>
				<tr>
					<th>Title</th>
					<th>Description</th>
					<th>Status</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="achievement in achievements" :key="achievement._id">
					<td>{{ achievement.name }}</td>
					<td>{{ achievement.description }}</td>
					<td>
						<button
							class="btn btn-sm"
							:class="{
								'btn-success': achievement.enabled,
								'btn-secondary': !achievement.enabled,
							}"
							@click="$emit('toggle', achievement._id)">
							{{ achievement.enabled ? "Enabled" : "Disabled" }}
						</button>
					</td>
					<td>
						<button
							class="btn btn-sm btn-info"
							@click="$emit('edit', achievement)">
							Edit
						</button>
						<button
							class="btn btn-sm btn-danger"
							@click="$emit('delete', achievement._id)">
							Delete
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script setup>
	const props = defineProps({
		achievements: {
			type: Array,
			required: true,
		},
	})
</script>
